<template>
  <LinkWrapper
    v-if="content"
    class="w-full overflow-hidden rounded shadow-md md:min-h-36 md:h-auto md:w-80 max-h-48 h-[calc((100vw_-_32px)_*_0.4)]"
    :link-url="content.linkUrl"
    :is-external-link="content.isExternalLink"
  >
    <div
      class="box-border relative w-full h-full p-4 text-xs md:p-6"
      :class="setCmsTemplateClasses(content.template, 'service-banner')"
    >
      <ContentfulImage
        class="absolute w-10 bottom-4 right-4 md:bottom-6 md:right-6 md:w-16"
        :entry="content.contentImage"
        :width="64"
        :height="64"
        fit="scale"
      />
      <div class="md:max-w-[75%]">
        <span class="text-xs text">{{ content.preTitle }}</span>
        <h3 class="mt-2 mb-4 text-sm font-bold title lg:text-lg">{{ content.title }}</h3>
      </div>
      <CButton
        v-if="content.buttonText"
        class="text-xs font-bold bottom-4 md:bottom-6 md:px-8"
        variant="secondary"
        size="small"
      >
        {{ content?.buttonText }}
      </CButton>
    </div>
  </LinkWrapper>
</template>

<script setup lang="ts">
import { setCmsTemplateClasses } from '@/config/cms';
import type { RandomBanner } from '@/types/contentful';

type Props = {
  content?: RandomBanner;
};

withDefaults(defineProps<Props>(), {
  content: undefined,
});
</script>

<script lang="ts">
export default defineComponent({
  name: 'ServiceBanner',
});
</script>
